import { Dispatcher } from "../../../../../react-core/Flux/Dispatcher";
import { FluxResponse } from "../../../../Admin/Adviser/Stores/Variable";
import { DashboardFilterStoreStatic } from "./DashboardFilterStoreStatic";
import { NotificationFilterStoreStatic } from "./NotificationFilterStoreStatic";

export const DashboardFilterDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const DashboardFilterStore: DashboardFilterStoreStatic = new DashboardFilterStoreStatic();

export const NotificationFilterDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const NotificationFilterStore: NotificationFilterStoreStatic = new NotificationFilterStoreStatic();
